module.exports = __webpack_public_path__ + "media/images/landing/icon-frequency-878f469e215c0fc5496d1468b18decec.svg";